/* eslint-disable max-len */
/* eslint-disable no-console */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	networkCount         : 0,
	followPath           : '',
	badgeCount           : { connectionBadgeCount: 0, contractBadgeCount: 0, contractLibBadgeCount: 0, followBadgeCount: 0 },
	pendingPath          : '',
	rFilter              : [],
	certificate          : 0,
	markingTab           : 0,
	networkRelations     : { initialCount: 0, relations: [], feedRelations: [] },
	catRealtions         : [],
	questionBankFilter   : [],
	connetions           : { value: 0, connectionCount: 0, mynetwork: [], pending: [], follow: [], block: [] },
	industries           : [],
	suggestions          : [],
	feedNetworkRelations : { page: 0, relations: [] },
	followPopup          : { follower: [], following: [], mutual: [], companyId: '' }
};

export const networkslice = createSlice({
	name     : 'network',
	initialState,
	reducers : {
		updateNetworkData : (state, action) =>
		{
			state.networkCount = action.payload;
		},
		updateFollowPath : (state, action) =>
		{
			state.followPath = action.payload;
		},
		updatePendingPath : (state, action) =>
		{
			state.pendingPath = action.payload;
		},
		updateRFilter : (state, action) =>
		{
			state.rFilter = action.payload;
		},
		certifciteTab : (state, action) =>
		{
			state.certificate = action.payload;
		},
		MarkingTab : (state, action) =>
		{
			state.markingTab = action.payload;
		},
		getNetworkRelations : (state, action) =>
		{
			state.networkRelations = { initialCount: action.payload.initialCount, relations: action.payload.relations, feedRelations: action.payload.feedRelations };
		},
		getCatRelations : (state, action) =>
		{
			state.catRealtions = action.payload;
		},
		questionBankFilterData : (state, action) =>
		{
			state.questionBankFilter = action.payload;
		},
		getRecommendedIndustries : (state, action) =>
		{
			state.industries = action.payload;
		},
		updateBadgeCount : (state, action) =>
		{
			state.badgeCount = { ...state.badgeCount, ...action.payload };
		},
		getConnectionData : (state, action) =>
		{
			state.connetions = { ...state.connetions, ...action.payload };
		},
		getSuggestions : (state, action) =>
		{
			state.suggestions = action.payload;
		},
		setFeedNetworkRelation : (state, action) =>
		{
			state.feedNetworkRelations = { ...state?.feedNetworkRelations, ...action.payload };
		},
		setFollowPopup : (state, action) =>
		{
			state.followPopup = { ...state?.followPopup, ...action.payload };
		}
	}
});

export const { updateNetworkData, updateFollowPath, updatePendingPath, updateRFilter, certifciteTab, MarkingTab, getRecommendedIndustries, getConnectionData, getNetworkRelations, getCatRelations, getSuggestions, updateBadgeCount, setFeedNetworkRelation, setFollowPopup } = networkslice.actions;
export default networkslice.reducer;